import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportMachinesPageHeader, ImportMachinesUploadCvs } from '@/components/pages/Machines/Import'

import { useImportMachine } from './Import.hooks'

const ImportMachine: VFC = () => {
  const { importCsvMachine, loading } = useImportMachine()
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = { idx: 0, nameIdx: 1, typeNameIdx: 2 }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importCsvMachine(formData)
    }
  }

  return (
    <>
      <ImportMachinesPageHeader />
      <ImportMachinesUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportMachine.displayName = 'ImportMachine'
export default ImportMachine
